import { createEntityAdapter, EntityState, Update } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as baseState from '../../../core/models/base-state/base-state';
import { PatientLetter } from '../../models/patient-letter';
import * as actions from '../actions/letters.actions';

export const lettersFeatureKey = 'letters';

export interface LettersState extends EntityState<PatientLetter> {
  baseState: baseState.BaseState;
  selectedLetterId: number | null;
  getLetterIsLoading: boolean;
}

export const lettersAdapter = createEntityAdapter<PatientLetter>({
  selectId: letter => letter.patientLetterId,
});

export const initialState: LettersState = lettersAdapter.getInitialState({
  baseState: baseState.createBaseState(undefined),
  selectedLetterId: null,
  getLetterIsLoading: false,
});

export const lettersReducer = createReducer<LettersState>(
  initialState,
  on(actions.getPatientLetters, (state): LettersState => {
    return {
      ...lettersAdapter.removeAll(state),
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: true,
      },
      selectedLetterId: null,
    };
  }),

  on(actions.getPatientLettersSuccess, (state, { letters }): LettersState => {
    if (letters !== null) return lettersAdapter.addMany(letters, state);
    return state;
  }),

  on(actions.getPatientLettersSuccess, (state): LettersState => {
    return {
      ...state,
      baseState: {
        ...state.baseState,
        error: null,
        isLoading: false,
      },
    };
  }),

  on(actions.getPatientLettersFailure, actions.getPatientLetterFailure, (state, { error }): LettersState => {
    return {
      ...state,
      baseState: {
        ...state.baseState,
        error,
        isLoading: false,
      },
    };
  }),

  on(actions.getPatientLetterSuccess, (state, { letter }): LettersState => {
    const i = state.ids.findIndex((fi: string | number) => fi == letter.patientLetterId);

    if (i < 0) return lettersAdapter.addOne(letter, state);

    const updatedLetter: Update<PatientLetter> = {
      id: letter.patientLetterId,
      changes: {
        ...letter,
      },
    };

    return lettersAdapter.updateOne(updatedLetter, state);
  }),

  on(
    actions.getPatientLetterSuccess,
    actions.getPatientLetterFailure,
    (state): LettersState => ({
      ...state,
      getLetterIsLoading: false,
    })
  ),

  on(
    actions.getPatientLetter,
    (state, { letterId }): LettersState => ({
      ...state,
      selectedLetterId: letterId,
      getLetterIsLoading: true,
    })
  )
);
